import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import veggieIcon from '../../Images/veggie-favicon.png';
import GeneralService from '../../services/general.service';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreaters } from "../../Redux/index";
import Loader from '../Includes/Loader';

export default function SignIn({ onSignIn }) { // Accept onSignIn prop
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const userActions = bindActionCreators(actionCreaters, dispatch);
    const navigate = useNavigate(); // Initialize navigate hook

    const handleSignIn = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await GeneralService.login({ username, password });
            console.log("Login response:", response);
            
            const { data } = response;
            
            if (!data) {
                throw new Error("Invalid response data");
            }
            
            const { token } = data; // Changed from access_token to token based on response
            
            // Handle the case where user data might be structured differently
            let userId, firstName, lastName, userImage;
            
            if (data.admin) {
                // If user is in admin property based on your API response
                const { id, name, email, profile_image } = data.admin || {};
                userId = id;
                firstName = name || '';
                lastName = '';
                userImage = profile_image;
            } else {
                // If user properties are directly in data
                userId = data.id;
                firstName = data.first_name || data.firstName || data.name || '';
                lastName = data.last_name || data.lastName || '';
                userImage = data.image || data.profileImage || data.profile_image;
            }
            
            // Ensure we have an ID before proceeding
            if (!userId) {
                throw new Error("User ID not found in response");
            }

            userActions.logIn({
                accessToken: token,
                id: userId,
                name: `${firstName || ''} ${lastName || ''}`.trim(),
                image: userImage,
            });

            // Call the onSignIn prop function if it exists
            if (onSignIn && typeof onSignIn === 'function') {
                onSignIn();
            }

            // Use React Router's navigate instead of directly changing window.location
            navigate("/dashboard");
        } catch (error) {
            console.error("Login error:", error);
            if (error?.response?.status === 401) {
                setError("Invalid username or password");
            } else {
                setError(error.message || "An error occurred during login");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid login-bg">
            <div className="row h-100 align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
                <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                    <div className="bg-light rounded p-4 my-4 mx-3 shadow-lg">
                        {/* Logo container - changed to center alignment */}
                        <div className="d-flex align-items-center justify-content-center mb-3">
                            <a href="/" className="text-center">
                                <img src={veggieIcon} style={{ width: "200px" }} alt="logo" />
                            </a>
                        </div>

                        <div className="form-floating mb-3">
                            <input
                                type="text"
                                className="form-control"
                                id="floatingInput"
                                placeholder="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                            <label htmlFor="floatingInput">Username</label>
                        </div>

                        <div className="form-floating mb-4">
                            <input
                                type="password"
                                className="form-control"
                                id="floatingPassword"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <label htmlFor="floatingPassword">Password</label>
                        </div>

                        <button
                            type="button"
                            className={`btn btn-primary py-3 w-100 mb-4 ${loading ? 'disabled' : ''}`}
                            onClick={handleSignIn}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                'Login'
                            )}
                            {loading ? ' Login...' : ''}
                        </button>

                        {error && <p className="text-danger text-center">{error}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}